module.exports = __webpack_public_path__ + "static/media/chevron-gauche-medium.126c6628.png";